import { ComplianceLayout, COMPANY } from "@/components/ComplianceLayout";

export default function CreditGuide() {
  return (
    <ComplianceLayout
      kicker="Compliance"
      title="Credit Guide"
      description="OzyLoans Credit Guide — services, lender panel, commissions and complaints process. ACL #485752, AFCA #618333, MFAA #246073."
      path="/credit-guide"
    >
      <p>This Credit Guide is provided to you by <strong>{COMPANY.name}</strong> in accordance with our obligations under the National Consumer Credit Protection Act 2009 (Cth). It contains key information you should know before we provide credit assistance.</p>

      <h2>About us</h2>
      <ul>
        <li><strong>Business name:</strong> {COMPANY.name}</li>
        <li><strong>Australian Credit Licence (ACL/CRN):</strong> {COMPANY.acl}</li>
        <li><strong>MFAA Member Number:</strong> 246073</li>
        <li><strong>Address:</strong> {COMPANY.addressLine1}, {COMPANY.addressLine2}, {COMPANY.addressLine3}</li>
        <li><strong>Phone:</strong> <a href={`tel:${COMPANY.phoneTel}`}>{COMPANY.phone}</a></li>
        <li><strong>Email:</strong> <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
      </ul>

      <h2>The services we provide</h2>
      <p>{COMPANY.name} provides credit assistance to clients in connection with commercial finance, business finance, private credit (non-bank) facilities, and refinance / take-out solutions for short-term bridging loans. We do not provide credit ourselves — we introduce clients to lenders on our panel and assist with the application process.</p>

      <h2>Our lender panel</h2>
      <p>We work with a panel of Australian banks and non-bank / private lenders. A current list of lenders we deal with is available on request. The lender we recommend to you will depend on your specific objectives, circumstances and the products available to you.</p>

      <h2>Fees and charges</h2>
      <p>In most cases we are paid a commission by the lender when a loan settles. The commission we receive varies between lenders and product types but is typically in the range of <strong>0.4% – 1.0% upfront</strong> of the loan amount, plus an ongoing trail commission of <strong>0% – 0.30% p.a.</strong> Where a fee is payable directly by you, we will disclose it in writing before you proceed.</p>
      <p>You can request a written estimate of the fees and commissions payable in connection with your loan, including a reasonable estimate of those amounts and how they are calculated.</p>

      <h2>Conflicts of interest</h2>
      <p>Because we are paid by lenders, we may have a conflict of interest. We manage this by acting in your best interests, recommending only products that are not unsuitable for you, and providing transparent disclosure of any commissions we receive.</p>

      <h2>If you have a complaint</h2>
      <p>If you are not satisfied with our services, please contact us in the first instance using the details above so we can attempt to resolve the issue through our internal dispute resolution process.</p>
      <p>If you are not satisfied with our response, you can contact our external dispute resolution provider:</p>
      <ul>
        <li><strong>Australian Financial Complaints Authority (AFCA)</strong></li>
        <li>Member number: <strong>{COMPANY.afca}</strong></li>
        <li>Phone: <a href="tel:1800931678">1800 931 678</a></li>
        <li>Web: <a href="https://www.afca.org.au" target="_blank" rel="noopener noreferrer">afca.org.au</a></li>
      </ul>
    </ComplianceLayout>
  );
}
